import * as React from 'react'
import { TextField, StandardTextFieldProps } from "@material-ui/core"

interface AutoCheckInputProps extends StandardTextFieldProps {
    notNull?: boolean,
    email?: boolean,
    mobile?: boolean,
    max?: number,
    min?: number,
    nationalCode?: string
}

const mobileRegex: { [code: string]: RegExp } = {
    '86': /^1[345789]\d{9}$/,
    '1': /^[2-9]\d{2}[2-9](?!11)\d{6}$/,
    '852': /^[569]\d{3}\-?\d{4}$/,
    '853': /^6\d{3}\-?\d{4}$/,
    '886': /^9\d{8}$/
}

const AutoCheckInput = ({ nationalCode, notNull, email, mobile, max, min, onChange, ...rest }: AutoCheckInputProps) => {

    const [state, setState] = React.useState({
        error: false,
        helperText: ''
    })
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (onChange) {
            onChange(event)
        }
        if (value) {
            setState({ error: false, helperText: '' })
        }
    }
    const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (notNull && value.length < 1) {
            setState({ error: true, helperText: `请输入${rest.label}` })
            return;
        }
        if (email && !/^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/.test(value)) {
            setState({ error: true, helperText: `${rest.label}格式错误，请检查后重新输入` })
            return;
        }

        let defaultNationalCode = '86'
        if (nationalCode) {
            defaultNationalCode = nationalCode
        }
        if (mobile && mobileRegex[defaultNationalCode] && !mobileRegex[defaultNationalCode].test(value)) {
            setState({ error: true, helperText: `${rest.label}格式错误，请检查后重新输入` })
            return;
        }
        setState({ error: false, helperText: '' })
    }
    return <TextField {...rest} style={{ ...rest.style, minHeight: '66px' }} onBlur={handleBlur} error={state.error} onChange={handleChange} helperText={state.helperText} color="secondary" />
}

export default AutoCheckInput